"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilterGroup_1 = require("./FilterGroup");
/** Meilisearch filters. */
var Filters = /** @class */ (function () {
    /** Initializing query. */
    function Filters() {
        this.groups = [];
    }
    /** Adding AND WHERE clause. */
    Filters.prototype.where = function (callback, value, operator) {
        return this.handleWhere("AND", callback, value, operator);
    };
    /** Adding OR where clause. */
    Filters.prototype.orWhere = function (callback, value, operator) {
        return this.handleWhere("OR", callback, value, operator);
    };
    /** Handling where clauses internally. */
    Filters.prototype.handleWhere = function (type, callback, value, operator) {
        var group = new FilterGroup_1.default(type);
        if (typeof callback === "function") {
            this.groups.push(callback(group));
            return this;
        }
        if (!value)
            return this;
        group.where(callback, value, operator);
        this.groups.push(group);
        return this;
    };
    /** Formatting to meilisearch filter format. */
    Filters.prototype.format = function () {
        return this.groups.reduce(function (formated, group, index) {
            return "".concat(formated).concat(formated ? " " : "").concat(group.format(index));
        }, "");
    };
    return Filters;
}());
exports.default = Filters;
